export default "__VITE_ASSET__CcbJy3i2__"